import { render, staticRenderFns } from "./MerchantDetails/MerchantReturn.html?vue&type=template&id=5c23c11b&scoped=true&external"
import script from "./MerchantReturn.vue?vue&type=script&lang=js"
export * from "./MerchantReturn.vue?vue&type=script&lang=js"
import style0 from "./MerchantReturn.vue?vue&type=style&index=0&id=5c23c11b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c23c11b",
  null
  
)

export default component.exports